import { ReactComponent as InfoIcon } from '@/assets/icon_info.svg';
import React from 'react';
import { FiMessageCircle } from 'react-icons/fi';

import { ProtocoloExecutado } from '@/models/ProtocoloExecutado';

import { useAuth } from '@/features/auth/providers/AuthProvider/hooks';
import PrescricoesButton from '@/features/prescricao-livre/components/PrescricoesButton';
import { useEnterpriseContext } from '@/features/enterprise/contexts/EnterpriseContext';

import ButtonSmall from '@/components/ButtonSmall';

import PatientSection from '@/features/enterprise/components/DadosAtendimento/PatientSection';
import { usePatientDisplay } from '@/features/enterprise/hooks/useEncounter';
import { useHelpCenterContext } from '@/features/helpcenter/contexts/HelpCenterContext';
import AutoriaProtocolo from '../AutoriaProtocolo';
import {
  Container,
  ExecucaoInfo,
  HeaderActions,
  HeaderColumn,
  HeaderRow,
  HeaderSeparator,
  Info,
} from './styles';

type Props = { protocolo: ProtocoloExecutado };
type DetailsProps = {
  autoria: ProtocoloExecutado['autoria'];
  timeoutInMS?: number;
};

/**
 * TODO: Generalizar este componente
 * Comportamento semelhante ao de SecondaryMenu, com a execção que o dropdown é
 * exibido via hover ao invés de onclick
 */
const AutoriaInfoButton: React.FC<DetailsProps> = ({
  autoria,
  timeoutInMS = 300,
}) => {
  const [menuShow, setMenuShow] = React.useState(false);
  const [displayTimeout, setDisplayTimeout] = React.useState<NodeJS.Timeout>();

  React.useEffect(() => {
    return () => clearTimeout(displayTimeout);
  }, [displayTimeout]);

  return (
    autoria && (
      <Info
        onMouseEnter={() => {
          clearTimeout(displayTimeout);
          setMenuShow(true);
        }}
        onMouseLeave={() => {
          clearTimeout(displayTimeout);
          setDisplayTimeout(setTimeout(() => setMenuShow(false), timeoutInMS));
        }}
      >
        <ButtonSmall>
          <InfoIcon />
        </ButtonSmall>
        {menuShow && <AutoriaProtocolo autoria={autoria} />}
      </Info>
    )
  );
};

const HeaderTitleProtocoloExecutado: React.FC<Props> = ({
  protocolo: { nome, autoria, numero_execucao },
}) => {
  const { user } = useAuth();
  const [{ mode }] = useEnterpriseContext();
  const {
    actions: { dispatchOpenModal },
  } = useHelpCenterContext();

  const {
    hasMinimalDisplayProperties: canDisplayPatient,
  } = usePatientDisplay();

  const contatoEmail = React.useMemo(() => {
    if (user && user.empresa) {
      return user.empresa.email_contato;
    }

    return null;
  }, [user]);

  const onButtonSupportClick = React.useCallback(() => {
    dispatchOpenModal(0);
  }, [dispatchOpenModal]);

  return (
    <Container>
      <HeaderColumn>
        <HeaderRow>
          <h1>{nome}</h1>
          {autoria && <AutoriaInfoButton autoria={autoria} />}
        </HeaderRow>
        <ExecucaoInfo>Número de execução: {numero_execucao}</ExecucaoInfo>
      </HeaderColumn>

      {canDisplayPatient && (
        <>
          <HeaderSeparator />
          <HeaderColumn>
            <PatientSection mode="clean" />
          </HeaderColumn>
        </>
      )}

      <HeaderActions>
        {mode === 'integrated' && !!contatoEmail && (
          <ButtonSmall onClick={onButtonSupportClick}>
            <FiMessageCircle size={22} />
            Ajuda
          </ButtonSmall>
        )}

        <PrescricoesButton />
      </HeaderActions>
    </Container>
  );
};

export default HeaderTitleProtocoloExecutado;
